import { useState } from 'react'
import { X, AlertTriangle } from 'lucide-react'

interface ResetBankrollModalProps {
  onClose: () => void
  isPending: boolean
  isError: boolean
  onConfirm: (reason: string) => void
  entityLabel: string
}

/** Sección 8/14/16 del encargo P0.23 -- "Reiniciar" NUNCA borra historial: cierra el ciclo
 * actual y deja el anterior consultable. La confirmación debe dejarlo explícito para que el
 * usuario no crea que está perdiendo sus datos. */
export function ResetBankrollModal({ onClose, isPending, isError, onConfirm, entityLabel }: ResetBankrollModalProps) {
  const [reason, setReason] = useState('')

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 p-4" onClick={onClose}>
      <div className="card w-full max-w-sm p-5 space-y-4 border-warn/40" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <p className="text-sm font-black text-text flex items-center gap-1.5">
            <AlertTriangle className="h-4 w-4 text-warn" /> Reiniciar {entityLabel}
          </p>
          <button onClick={onClose} className="p-1 text-text-dim hover:text-text">
            <X className="h-4 w-4" />
          </button>
        </div>

        <p className="text-[11px] text-text-dim leading-relaxed bg-warn-soft/10 border border-warn/20 rounded-xl p-2.5">
          Esto cierra tu ciclo actual y empieza uno nuevo desde cero. <strong className="text-text">Tu historial NO se
          borra</strong> -- podrás seguir consultando este ciclo como histórico.
        </p>

        <div className="space-y-2">
          <label className="text-[10px] font-bold uppercase text-text-dim">Motivo (opcional)</label>
          <input
            type="text" placeholder="Ej: quiero empezar de nuevo" value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full bg-panel-elevated border border-border/60 rounded-xl px-3 py-2.5 text-xs font-medium text-text focus:outline-none focus:border-warn/50"
          />
        </div>

        {isError && (
          <p className="text-[10px] text-danger">
            {entityLabel === 'Mi Banca'
              ? 'No se pudo reiniciar. Revisa que no tengas apuestas ni boletos de La Quiniela pendientes de liquidar.'
              : 'No se pudo reiniciar. Revisa que no tengas apuestas pendientes.'}
          </p>
        )}

        <button
          disabled={isPending}
          onClick={() => onConfirm(reason)}
          className="w-full py-2.5 rounded-xl bg-warn text-black text-xs font-black uppercase tracking-wider disabled:opacity-40 disabled:pointer-events-none"
        >
          Confirmar reinicio
        </button>
      </div>
    </div>
  )
}
